import { render, staticRenderFns } from "./MarsAddPriceRecord.vue?vue&type=template&id=6017d495&scoped=true&"
import script from "./MarsAddPriceRecord.vue?vue&type=script&lang=js&"
export * from "./MarsAddPriceRecord.vue?vue&type=script&lang=js&"
import style0 from "./MarsAddPriceRecord.vue?vue&type=style&index=0&id=6017d495&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6017d495",
  null
  
)

export default component.exports